import transactionTypes from 'js/constants/transactionTypes';
import { isAU } from 'js/constants/crux';
import moment from 'moment/moment';

export const getTransactionType = (saleType = '') => {
    const soldList = isAU ? transactionTypes.SOLD : transactionTypes.SOLD_NZ;
    const transferredList = isAU ? transactionTypes.TRANSFERRED : transactionTypes.TRANSFERRED_NZ;
    const saleTypeLower = saleType?.toLowerCase();

    // Check if saleTypeLower is included in the lowercase version of each list
    if (soldList.some(type => type.toLowerCase() === saleTypeLower)) {
        return 'Sold';
    }
    if (transferredList.some(type => type.toLowerCase() === saleTypeLower)) {
        return 'Transferred';
    }
    return 'Transacted';
};

export const renderSalePrice = ({
    saleType,
    soldDate,
    salePrice,
    isTimeline,
    isExactPrice,
    isAgentsAdvice,
    isPriceWithheld,
    noPriceAvailableText,
    undisclosedSalesAccess,
    undisclosedSalesFeature,
    noPriceAndDateAvailableText,
    undisclosedText,
}) => {
    const hasDate = soldDate !== '';
    const agentsAdvice = isAgentsAdvice === true && !parseInt(salePrice, 10);
    const noUndisclosedSales = isPriceWithheld && !(undisclosedSalesAccess && !undisclosedSalesFeature);

    const _salePrice = determineSalePrice({
        agentsAdvice,
        noUndisclosedSales,
        isExactPrice,
        undisclosedText,
        salePrice,
        hasDate,
        noPriceAndDateAvailableText,
        noPriceAvailableText,
    });

    if (isExactPrice || _salePrice.hasNoValueToRender) {
        return _salePrice.value;
    }

    const transactionType = getTransactionType(saleType);
    return buildDisplayText({
        isTimeline,
        transactionType,
        hasDate,
        soldDate,
        _salePrice: _salePrice.value,
    });
};

const determineSalePrice = ({
    agentsAdvice,
    noUndisclosedSales,
    isExactPrice,
    undisclosedText,
    salePrice,
    hasDate,
    noPriceAndDateAvailableText,
    noPriceAvailableText,
}) => {
    if (agentsAdvice || noUndisclosedSales) {
        return {value: `${isExactPrice ? '' : ', '}${undisclosedText}`, hasNoValueToRender: false};
    }

    if (!salePrice && salePrice !== 0) {
        const hasNoValueToRender = !hasDate;
        const value = `${isExactPrice || hasNoValueToRender ? '' : '. '}${
            noPriceAndDateAvailableText || noPriceAvailableText || '-'
        }`;
        return {value, hasNoValueToRender};
    }

    return {
        value: `${isExactPrice ? '' : ' for '}$${parseInt(salePrice, 10).toLocaleString()}`,
        hasNoValueToRender: false
    };
};

const buildDisplayText = ({isTimeline, transactionType, hasDate, soldDate, _salePrice}) => {
    const introText = isTimeline ? '' : 'Last ';
    let displayText = `${introText}${transactionType}${_salePrice}`;

    if (hasDate && !isTimeline) {
        const _soldDate = moment(soldDate).format('DD MMM YYYY');
        displayText = `${introText}${transactionType} on ${_soldDate}${_salePrice}`;
    }

    return displayText;
};